import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({
  selector: '[clickOutsideMenu]',
  standalone: true
})
export class ClickOutsideDirective {
  private readonly _elementRef = inject(ElementRef);

  @Output() clickOutsideMenu: EventEmitter<boolean | null> = new EventEmitter();

  @HostListener('document:click', ['$event.target']) onMouseEnter(targetElement) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    const menuImage = document.getElementById('menu_icon');
    if (!clickedInside && targetElement !== menuImage) {
      this.clickOutsideMenu.emit(null);
    }
  }
}
